// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#slideout {
  background: #dbe2e9;
  color: #333;
  position: fixed;
  top: 0;
  right: 0px;
  width: 500px;
  height: 100%;
  z-index: 100;
  transition-duration: 0.3s;
  overflow-y: auto;
}
#slideout form {
  display: block;
  padding: 20px;
}
#slideout textarea {
  display: block;
  height: 100px;
  margin-bottom: 6px;
  width: 250px;
}
#slideout.on {
  right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/pop-out-panel/pop-out-panel.component.less"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EAIA,yBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,cAAA;EACA,aAAA;AAAJ;AAEE;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAAJ;AAEE;EACE,QAAA;AAAJ","sourcesContent":["\n#slideout {\n    background: #dbe2e9;\n    color: #333;\n    position: fixed;\n    top: 0;\n    right: 0px;\n    width: 500px;\n    height: 100%;\n    z-index: 100;\n    -webkit-transition-duration: 0.3s;\n    -moz-transition-duration: 0.3s;\n    -o-transition-duration: 0.3s;\n    transition-duration: 0.3s;\n    overflow-y: auto;\n  }\n  #slideout form {\n    display: block;\n    padding: 20px;\n  }\n  #slideout textarea {\n    display:block;\n    height: 100px;\n    margin-bottom: 6px;\n    width: 250px;\n  }\n  #slideout.on {\n    right: 0;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
